export default import.meta.ROLLDOWN_FILE_URL_FgypUJRGvu1gMBGMxEKbxw